import { render, staticRenderFns } from "./NoClientSelected.vue?vue&type=template&id=b60b25ee&"
import script from "./NoClientSelected.vue?vue&type=script&lang=js&"
export * from "./NoClientSelected.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports